import { FC, useCallback, useEffect, useState } from "react";
import HighCharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";

import CustomTopPayorList from "../customTopPayorList";

import {
  PIE_CHART_OPTIONS,
} from "src/constants/highCharts";
import { StatisticsObjectType } from "../caseVolumeLineChart/types";
import { wrapperFunctionPieChart } from "src/helpers";
import { topPayor } from "src/pages/manufacturer/types";



const CustomTopPayorDetail: FC<StatisticsObjectType> = ({ StatisticsObjectType }): JSX.Element => {
  const [data, setData] = useState({});

  const populatePieChart = useCallback(() => {
    if (Array.isArray(StatisticsObjectType.top_payors_details)) {
      const allPayorData = StatisticsObjectType.top_payors_details.filter((item) => item.name !== "ALL TOP 10")
      const topPayorOptions = {
        ...PIE_CHART_OPTIONS,
        series: wrapperFunctionPieChart(allPayorData as topPayor[])
      };
      setData(topPayorOptions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [StatisticsObjectType.top_payors_details]);

  useEffect(() => {
    populatePieChart();
  }, [populatePieChart]);


  return (
    <div className="card">
      <div className="card-header">
        <h4 className="m-0 text-center">Top Payer Details</h4>
      </div>

      <div className="card-body p-0">
        {window.location.pathname.includes("statistics") || window.location.pathname.includes("territories") ? (
          <div className="row">
            <div className="col-12 col-sm-12 col-md-5 overflow-auto" style={{ maxHeight: 500 }}>
              <CustomTopPayorList StatisticsObjectType={StatisticsObjectType}/>
            </div>
            <div className="col-12 col-sm-12 col-md-7">
              <HighchartsReact highcharts={HighCharts} options={data}/>
            </div>
          </div>
          ) : <HighchartsReact highcharts={HighCharts} options={data}/>}
      </div>
    </div>
  );
};

export default CustomTopPayorDetail;
